import axios from "axios";
import { useState } from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import DataTable from "react-data-table-component";
import '../../styles/createcode.css'
import { CSVLink } from "react-csv";
import SidebarAdminMain from "../SidebarAdminMain";
import { BASE_URL, tableCustomStyles } from "../../App";
import swal from "sweetalert";


function Createcode() {
  const [numberOfCodes, setNumberOfCodes] = useState("");
  const [code, setCode] = useState("");
  const [id, setId] = useState("");
  const [phone, setPhone] = useState("");
  const [value, setValue] = useState("");
  const [CodeResponce, setCodeResponce] = useState([]);



  const token = localStorage.getItem('token');
  
  const axiosInstance = axios.create({
    baseURL: `${BASE_URL}`,
    headers: {
      'Content-Type': 'application/json',
      "ngrok-skip-browser-warning": "any",
      Authorization: `Bearer ${token}`,
    },
  });

  // الريكويست الخاص بإنشاء الأكواد
  
  const handleCreateCode = async (event) => {
    event.preventDefault();
  
    try {
      const response = await axiosInstance.post("/api/codes", {
        numberOfCodes,
        value,
      });
      console.log("API Response:", response.data);
      if (response.data && response.data.data && Array.isArray(response.data.data)) {
        setCodeResponce(response.data.data);
      } else {
        setCodeResponce([]);
      }
      setNumberOfCodes("");
      setValue("");
    } catch (error) {
      console.error(error);
      setCodeResponce([]);
    }
  };
  

  // او الكود Id الريكويست الخاص ب البحث عن الأكواد بالأسم او 

  const [SearchCodeResponce, setSearchCodeResponce] = useState([]);
  const handleSearchCode = async(event) => {
      event.preventDefault();
      try {
          await axiosInstance.post("/api/codes/search", { code, id, phone })
              .then(response => {
                  setSearchCodeResponce(response.data.data);
                  console.log(response.data.data);
              });
          setCode("");
          setId("");
          setPhone("");

      } catch (e) {
        if(e.response.status === 422) {
            swal({
                title: "! هذا الأسم لم يستخدم اكواد من قبل",
                text: "Id يرجي التحقق من رقم الإسم او ",
                icon: "warning",
                button: "! اعد المحاولة",
              });
        }
      }
  }




  // الريكويست الخاص بمسح الكود

  const deleteRow = async(id, token) => {
      try {
          await axios.delete(`${BASE_URL}/api/codes/${id}`, {
              headers: {
                  Authorization: `Bearer ${token}`,
              },
          });
      } catch (error) {
      }
  };

  // الريكويست الخاص بإعادة استخدام الكود

  const clearRow = async(id) => {
      try {
        const token = localStorage.getItem('token');
          await axiosInstance.get(`/api/codes/clear/${id}`, {
              headers: {
                  Authorization: `Bearer ${token}`,
              },
          });
          // Refresh the codes after clearing
          const updatedCodes = CodeResponce.filter(code => code.id !== id);
          setCodeResponce(updatedCodes);
      } catch (error) {
        //   console.log(error);
      }
  }


  // الفانشكن المسئولة عن مسح الكود

  const handleDeleteClick = async (id) => {
    const token = localStorage.getItem('token');
    try {
        await deleteRow(id, token);
        const updateCode = CodeResponce.filter(row => row.id !== id);
        const updateCodes = SearchCodeResponce.filter(row => row.id !== id);
        setCodeResponce(updateCode);
        setSearchCodeResponce(updateCodes);
    } catch (error) {
        // console.error(error);
    }
};
  

  // الفانشكن المسئولة عن اعادة استخدام الكود


const handleClearClick = async (id) => {
    const token = localStorage.getItem('token');
    try {
        await clearRow(id, token);
        const updateCode = CodeResponce.filter(row => row.id !== id);
        const updateCodes = SearchCodeResponce.filter(row => row.id !== id);
        setCodeResponce(updateCode);
        setSearchCodeResponce(updateCodes);
    } catch (error) {
        // console.error(error);
    }
};

  const columns = [{
          name: "ID",
          selector: row => row.id || '',
          sortable: true,
      },
      {
          name: "Price ",
          selector: row => row.value || '',
          sortable: true,
      },
      {
          name: "Code ",
          selector: row => row.code || '',
          grow: 3
      },
      {
          name: "Phone ",
          selector: row => row.phone || 'غير محدد',
          grow: 2
      },
      {
          name: "created_at",
          selector: row => row.created_at || '',
          grow: 2,
          sortable: true,

      },
      {
          name: "updated_at",
          selector: row => row.updated_at || '',
          grow: 2
      },


      {
          name: "Status",
          cell: (row) => {
            if (row.usedBy === null || row.usedBy === "") {
              return <button style={{ background: "#", border: "none" }} className="btn btn-secondary">not used</button>;
            } else {
              return <button style={{background:"#" , border: "none"}} className="btn btn-primary">{row.usedBy}</button>;
            }
          },
          grow: 3,
      },
      {
          name: "Clear",
          cell: (row) => <button 
            style={{ background: "#", border: "none"}}
            className="btn btn-success"
            disabled={row.usedBy === null || row.usedBy === ""}
            onClick={() => {
              if (window.confirm('هل انت متأكد من تفريغ هذا الكود')) {
                handleClearClick(row.id);
              }
            }}
          >
            Clear
          </button>,
          grow: 2,
      },
      {
          name: "Delete",
          cell: row => <button style={{ background: "#", border: "none" }}
          className="btn btn-danger"
          onClick={() => {
            if (window.confirm('هل انت متأكد من حذف هذا الكود')) {
              handleDeleteClick(row.id);
            }
          }}>Delete</button>,
          grow: 2,
      },

      // {
    
  ];
  return ( 
  <>
      <div className="d-flex">

      <div className="create-code">

      <div className="main-title">انشاء الأكواد</div>

      <Container>

      <Row>

      <Col lg={12}>
      <div className="quiz-content">
      <div className="codes pt-5">

      <div className="create-box">
      <h2 className="create mb-4">انشاء الأكواد</h2> 
      <Form onSubmit={handleCreateCode}>
      <Form.Group className="mb-3" controlId="formBasicNumber">
      <Form.Label className="ms-2">عدد الأكواد</Form.Label> 
      <Form.Control type="number" placeholder="ادخل عدد الأكواد" name="numberOfCodes" required onChange={(e) => setNumberOfCodes(e.target.value)}/>
      </Form.Group>

      <Form.Group className="mb-3 ms-lg-4 me-lg-4 me-md-4 ms-md-4 ms-0 me-0" controlId="formBasicNumber">
        <Form.Label className="ms-2">سعر الأكواد</Form.Label> 
        <Form.Control type="number" placeholder="ادخل سعر الكود"
        name="value"
      required onChange={(e) => setValue(e.target.value)}
      /> </Form.Group> 
      <Button variant="primary"
      type="submit"
      className="create-button">
      انشئ</Button> 
      </Form>

      </div> 


      <div className="table-code">


      <DataTable className="table"
                     customStyles={tableCustomStyles}

      columns={columns}
      data={CodeResponce && Array.isArray(CodeResponce) ? CodeResponce : []}
      pagination fixedHeader highlightOnHover 
      actions={ 
      <CSVLink
          data={CodeResponce && Array.isArray(CodeResponce) ? CodeResponce : []}
          filename="GeneratedCodes"
          className="btn btn-success mb-3 mt-4 me-2">Export File Excel</CSVLink>
      }
      />

      </div>

      <div className="create-box mt-5">
      <h2 className="create mb-4">البحث عن الأكواد</h2> 
      <Form onSubmit={handleSearchCode}>

      <Form.Group className="mb-3"
      controlId="formBasicNumber">
      <Form.Label className="ms-2">الكود</Form.Label>
      <Form.Control type="text"
      placeholder="ادخل الكود"
      name="code"
      onChange={(e) => setCode(e.target.value)}
      /> 
      </Form.Group>

      <Form.Group className="mb-3 ms-lg-4 me-lg-4 me-md-4 ms-md-4 ms-0 me-0"
      controlId="formBasicNumber">
      <Form.Label className="ms-2">أو الأسم id الطالب</Form.Label> 
      <Form.Control type="text"
      placeholder="id الطالب"
      name="id"
      onChange={(e) => setId(e.target.value)}
      /> 
      </Form.Group>

      <Form.Group className="mb-3 ms-lg-4 me-lg-4 me-md-4 ms-md-4 ms-0 me-0"
      controlId="formBasicPhone">
      <Form.Label className="ms-2">أو رقم الهاتف</Form.Label> 
      <Form.Control type="text"
      placeholder="رقم الهاتف"
      name="phone"
      onChange={(e) => setPhone(e.target.value)}
      /> 
      </Form.Group> 
      <Button variant="primary"
      type="submit"
      className="search-button">
      ابحث</Button> 
      </Form>

      </div>    

      <div className="table-code">


      <DataTable className="table"
                           customStyles={tableCustomStyles}

      columns={columns}
      data={SearchCodeResponce && Array.isArray(SearchCodeResponce) ? SearchCodeResponce : []}
      pagination fixedHeader highlightOnHover 
  

      />

      </div>

      </div>  
      </div> 
      </Col>
      </Row> 
      </Container>


      </div> 
      <div className="sidebar">
      <SidebarAdminMain />
      </div> 
      </div> 
      </>

  )
}


export default Createcode;